import { Controller } from '@hotwired/stimulus';
import { autocomplete } from 'getaddress-autocomplete';

export default class extends Controller {
  static targets = [
    'addressSelection',
    'line1Field',
    'line2Field',
    'line3Field',
    'cityField',
    'countyField',
    'postcodeField',
  ];

  connect() {
    this.dkey = this.element.dataset.dkey;
    autocomplete(this.addressSelectionTarget.id, this.dkey, {
      output_fields: {
        line_1: this.line1FieldTarget.id,
        line_2: this.line2FieldTarget.id,
        line_3: this.line3FieldTarget.id,
        town_or_city: this.cityFieldTarget.id,
        county: this.countyFieldTarget.id,
        postcode: this.postcodeFieldTarget.id,
      },
    });
    document.addEventListener(
      'getaddress-autocomplete-address-selected',
      this.addressSelected.bind(this)
    );
  }

  addressSelected(e) {
    this.line1FieldTarget.form.requestSubmit();
  }
}
